// extracted by mini-css-extract-plugin
export default {"logo":"Projects_logo__QEGYG","project":"Projects_project__9caDt"};